import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Ignore known ResizeObserver browser noise in development to avoid false crash overlays.
if (process.env.NODE_ENV !== "production") {
    const isResizeObserverNoise = (message) => typeof message === "string" && message.includes("ResizeObserver loop");

    window.addEventListener(
        "error",
        (event) => {
            if (isResizeObserverNoise(event?.message)) {
                event.preventDefault();
            }
        },
        true,
    );
}

ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>,
    document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
